"use strict";

/* Real viewport height (mobile URL bars make 100vh lie) — same trick Suitsupply uses */
(function () {
  function setVH() {
    document.documentElement.style.setProperty("--screen-inner-height", window.innerHeight + "px");
  }
  window.addEventListener("resize", setVH);
  window.addEventListener("orientationchange", setVH);
  setVH();
})();

/* Mobile nav: slide-in panel + one-at-a-time accordion sections */
(function () {
  var toggle = document.getElementById("nav-toggle");
  var nav = document.getElementById("main-nav");
  if (!toggle || !nav) return;
  var closeBtn = document.getElementById("nav-close");

  function setOpen(open) {
    nav.classList.toggle("open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";
    if (!open) {
      nav.querySelectorAll(".nav-drop.open").forEach(function (d) { d.classList.remove("open"); });
    }
  }

  toggle.addEventListener("click", function () { setOpen(!nav.classList.contains("open")); });
  if (closeBtn) closeBtn.addEventListener("click", function () { setOpen(false); });

  // Section headers: tap to expand, closing any other open section
  nav.querySelectorAll(".nav-drop > button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (window.innerWidth > 1180) return; // desktop keeps hover behavior
      var drop = btn.parentElement;
      var wasOpen = drop.classList.contains("open");
      nav.querySelectorAll(".nav-drop.open").forEach(function (d) { d.classList.remove("open"); });
      if (!wasOpen) drop.classList.add("open");
    });
  });

  // Tapping any link closes the panel
  nav.addEventListener("click", function (e) {
    if (e.target.closest("a")) setOpen(false);
  });
})();

/* Campaign banners: whole tile navigates to its primary link */
(function () {
  document.querySelectorAll(".camp").forEach(function (camp) {
    var link = camp.querySelector(".camp-links a");
    if (!link) return;
    camp.style.cursor = "pointer";
    camp.addEventListener("click", function (e) {
      if (e.target.closest("a")) return; // real links handle themselves
      window.location.href = link.href;
    });
  });
})();

/* Shop ABR hero (Suitsupply-exact): links scroll up in normal flow over a
   viewport-fixed image; the image fades out once the section is scrolled
   past, and fades back when you return. */
(function () {
  var si = document.querySelector(".shop-index");
  if (!si) return;
  var fixed = si.querySelector(".si-fixed");
  if (!fixed) return;

  function update() {
    var r = si.getBoundingClientRect();
    // Suitsupply-exact: the links live in normal page flow at full brightness —
    // each sentence simply comes in from the bottom edge as you scroll.
    // The next section paints over the fixed image, so keep the image until it
    // is FULLY covered — never a sliver of background between them.
    var past = r.bottom < 8;
    fixed.style.opacity = past ? "0" : "1";
    fixed.style.pointerEvents = past ? "none" : "";
    fixed.style.visibility = r.bottom < -300 ? "hidden" : "visible";
  }

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
})();

/* Scroll-reveal animations (IntersectionObserver + scroll fallback) */
(function () {
  var els = Array.from(document.querySelectorAll(".reveal"));
  if (!els.length) return;

  function pending() { return els.filter(function (el) { return !el.classList.contains("in"); }); }

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  // Fallback: some environments never deliver IO callbacks — check on scroll too.
  function check() {
    var vh = window.innerHeight;
    pending().forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.88 && r.bottom > 0) el.classList.add("in");
    });
    if (!pending().length) {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    }
  }
  window.addEventListener("scroll", check, { passive: true });
  window.addEventListener("resize", check);
  check();
})();

/* Header search: icon toggles a drop-down search bar */
(function () {
  var btn = document.getElementById("search-toggle");
  var panel = document.getElementById("site-search");
  if (!btn || !panel) return;
  var input = document.getElementById("site-search-input");
  var closeBtn = document.getElementById("search-close");

  function setOpen(open) {
    panel.hidden = !open;
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    btn.classList.toggle("active", open);
    if (open && input) { setTimeout(function () { input.focus(); }, 40); }
  }

  btn.addEventListener("click", function (e) {
    e.stopPropagation();
    setOpen(panel.hidden);
  });
  if (closeBtn) closeBtn.addEventListener("click", function () { setOpen(false); btn.focus(); });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !panel.hidden) { setOpen(false); btn.focus(); }
  });

  // click outside closes it
  document.addEventListener("click", function (e) {
    if (panel.hidden) return;
    if (!panel.contains(e.target) && e.target !== btn) setOpen(false);
  });

  // don't submit an empty search
  panel.querySelector("form").addEventListener("submit", function (e) {
    if (!input.value.trim()) { e.preventDefault(); input.focus(); }
  });
})();

/* ============================================================
   Announcement bar rotator — cycles the messages so every kind
   of customer sees one aimed at them. Pauses on hover/focus and
   holds still for anyone who prefers reduced motion.
   ============================================================ */
(function () {
  var bar = document.getElementById("announce-rotator");
  if (!bar) return;
  var msgs = bar.querySelectorAll(".announce-msg");
  if (msgs.length < 2) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var i = 0, timer = null, DELAY = 4500;

  function show(n) {
    msgs[i].classList.remove("is-on");
    i = (n + msgs.length) % msgs.length;
    msgs[i].classList.add("is-on");
  }
  function start() { if (!timer) timer = setInterval(function () { show(i + 1); }, DELAY); }
  function stop() { clearInterval(timer); timer = null; }

  bar.addEventListener("mouseenter", stop);
  bar.addEventListener("mouseleave", start);
  bar.addEventListener("focusin", stop);
  bar.addEventListener("focusout", start);
  document.addEventListener("visibilitychange", function () {
    document.hidden ? stop() : start();
  });

  start();
})();
